import { connect } from 'react-redux'
import PlayInButton from './PlayInButton'
import PlayInButtonProps from './types'
import { openPlayInMediaDrawer, closePlayInMediaDrawer } from '../../dataStore/actions/ui/uiActions'
import constants, { mediaType } from '@bt-react/constants'
import { State } from '../../dataStore/reducers/reducerType'

type Dispatch = 'openMediaDrawer' | 'closeMediaDrawer'

const mapStateToProps = (state: State): Omit<PlayInButtonProps, Dispatch> => ({
  isActive: state.ui.selectedDrawer === constants.drawerType.PLAY_IN || state.room.mediaType === mediaType.PLAY_IN,
  videoListCount: state.playIn.selectedIDs ? state.playIn.selectedIDs.length : 0,
  disabled: false,
  mediaDrawerOpen: state.ui.selectedDrawer === constants.drawerType.PLAY_IN
})

const mapDispatchToProps = (dispatch): Pick<PlayInButtonProps, Dispatch> => ({
  openMediaDrawer: () => dispatch(openPlayInMediaDrawer()),
  closeMediaDrawer: () => dispatch(closePlayInMediaDrawer())
})

export default connect(mapStateToProps, mapDispatchToProps)(PlayInButton)
